<template>
    <CModal
        :show="showConfirm"
        :backdrop="false"
        :title="title"
        :color="color"
        @update:show="hide"
    >
        {{question}}
        <template v-slot:footer>
            <button type="button" class="btn btn-secondary cancel-button" @click="clickCancel($event)">{{cancelButtonText}}</button>
            <button type="button" :class="btnClasses + ' ok-button'" @click="clickOk($event)">{{okButtonText}}</button>
        </template>
    </CModal>
</template>

<script>
export default {
    props: {
        show: {type: Boolean, default: false},
        question: {type: String, default: ''},
        color: {type: String, default: 'white'},
        title: {type: String, default: ''},
        okButtonText: {type: String, default: 'Yes'},
        cancelButtonText: {type: String, default: 'No'},
        okCallback: {type: Function, default: null},
        cancelCallback: {type: Function, default: null},
        data: Object,
    },
    data() {
        return {
            showConfirm: false,
        }
    },
    methods: {
        hide() {
            this.showConfirm = false
            this.$emit('update:show', false);
        },
        clickCancel() {
            if (this.cancelCallback !== null) {
                this.cancelCallback(this.data);
            }
            this.hide();
        },
        clickOk() {
            if (this.okCallback !== null) {
                this.okCallback(this.data);
            }
            this.hide();
        },
    },
    computed: {
        btnClasses () {
            return [`btn btn-${this.color || 'primary'}`]
        }
    },
    watch: {
        show(showValue) {
            this.showConfirm = showValue;
        }
    }
}
</script>

<style lang="scss">

</style>